export default __webpack_public_path__ + "static/media/wedding_mansion_logo.980baa05.jpg";